import { EntityInterface } from 'shared/types/entityInterface';
import { SelectItem } from 'shared/types/selectItem';
import filter from 'lodash-es/filter';
import { SectionModel } from 'entities/section/model/sectionModel';

export enum ExplorerEntityTypes {
  SECTION = 'SECTION',
  FOLDER = 'FOLDER',
  FILE = 'FILE',
  TABLE = 'TABLE',
}

export type ExplorerEntityShortMeta = {
  id: string;
  type: ExplorerEntityTypes;
};
export type ExplorerEntityMeta = {
  id: string;
  type: ExplorerEntityTypes;
  name: string;
};

export const explorerEntitesItems: SelectItem<ExplorerEntityTypes>[] = [
  {
    id: ExplorerEntityTypes.SECTION,
    name: 'Раздел',
  },
  {
    id: ExplorerEntityTypes.FOLDER,
    name: 'Папка',
  },
  {
    id: ExplorerEntityTypes.FILE,
    name: 'Файл',
  },
  {
    id: ExplorerEntityTypes.TABLE,
    name: 'Таблица',
  },
];

export interface ExplorerModelInterface
  extends EntityInterface<{ in_trash: string | null }> {
  type: ExplorerEntityTypes;
}

export type ContentFolderItem = {
  id: string;
  type: ExplorerEntityTypes.FOLDER;
  name: string;
  last_change_date: string;
  files_amount: number;
  section_id: string | null;
  parent_id: string | null;
};
export type ContentFileItem = {
  id: string;
  type: ExplorerEntityTypes.FILE;
  name: string;
  last_change_date: string;
  username: string;
  preview_url: string | null;
  size: number;
  extension: string;
  is_favorite: boolean;
  section_id: string | null;
  folder_id: string | null;
};
export type ContentTableItem = {
  id: string;
  type: ExplorerEntityTypes.TABLE;
  name: string;
  last_change_date: string;
  username: string;
  is_favorite: boolean;
  section_id: string | null;
  folder_id: string | null;
};
export type ContentSectionItem = {
  id: string;
  type: ExplorerEntityTypes.SECTION;
  name: string;
  last_change_date: string;
  files_amount: number;
  preview_url: string | null;
};

export type ContentItem =
  | ContentFolderItem
  | ContentFileItem
  | ContentTableItem
  | ContentSectionItem;

export enum SortContentKey {
  NAME = 'NAME',
  LAST_CHANGE_DATE = 'LAST_CHANGE_DATE',
  EXTENSION = 'EXTENSION',
  FILES_AMOUNT = 'FILES_AMOUNT',
  SIZE = 'SIZE',
}
export enum SortContentOrder {
  DESC = 'DESC',
  ASC = 'ASC',
}

export const sortContentMap = {
  [SortContentKey.NAME]: {
    id: SortContentKey.NAME,
    name: 'Название',
  },
  [SortContentKey.LAST_CHANGE_DATE]: {
    id: SortContentKey.LAST_CHANGE_DATE,
    name: 'Изменено',
  },
  [SortContentKey.EXTENSION]: { id: SortContentKey.EXTENSION, name: 'Тип' },
  [SortContentKey.FILES_AMOUNT]: {
    id: SortContentKey.FILES_AMOUNT,
    name: 'Кол-во файлов',
  },
  [SortContentKey.SIZE]: { id: SortContentKey.SIZE, name: 'Вес' },
};

export const getActualSortContentMap = ({
  supportTypes,
}: {
  supportTypes: ExplorerEntityTypes[];
}) => {
  return filter(sortContentMap, (item) => {
    if (
      item.id === SortContentKey.FILES_AMOUNT &&
      !supportTypes.includes(ExplorerEntityTypes.FOLDER)
    ) {
      return false;
    }

    if (
      item.id === SortContentKey.SIZE &&
      !supportTypes.includes(ExplorerEntityTypes.FILE)
    ) {
      return false;
    }

    return true;
  });
};

export type PlacementParams = {
  sectionId: string;
  folderId?: string;
  name?: string;
  parentId?: string;
};

export type InitialPlacement = {
  initialName?: string;
  initialSectionId: string | null;
  initialFolderId: string | null;
};

// TODO: Перетащить
export type MergeInitialPlacement = InitialPlacement & {
  filterFoldersById?: string[];
  initialAllSections?: SectionModel[] | null;
};
